import "./panelDatasheet2.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { panelInformation } from "../../DataFiles/panelInformation";

const PanelDatasheet2 = (props) => {
  const { tableContent, index, panelData } = props;
  let panelInfo = panelData[index];
  const pageDetail = tableContent.find(
    (item) => item.title === "Product Data Sheets"
  );
  let panelDetail = panelInformation.find(
    (item) => item.brand === panelInfo.module
  );
  let panel = panelDetail.panelType.find(
    (item) => item.name === panelInfo.moduleType
  );
  const indexValue = panelData.length * 2;
  let page = tableContent[tableContent.length - 1].pageNo - indexValue;
  let pageIndex = index === 0 ? page + index + 1 : page + index + 2;

  return (
    <div id="panel-datasheet-two" className="panel-datasheet-two">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="pd2-body">
        <p>Panel</p>
        <img
          className="img"
          src={panel.panelSheet2}
          alt={panelDetail.brand}
        ></img>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageIndex : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default PanelDatasheet2;
